"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionMarkFill = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var QuestionMarkFill = function QuestionMarkFill() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0012 0zm1.2 18.6a.6.6 0 01-.6.6h-1.2a.6.6 0 01-.6-.6v-1.2a.6.6 0 01.6-.6h1.2a.6.6 0 01.6.6v1.2zm1.056-6.252a3.468 3.468 0 002.4-3.276V8.4A3.456 3.456 0 0013.2 4.944h-2.4A3.456 3.456 0 007.344 8.4V9a.6.6 0 00.6.6h.912a.6.6 0 00.6-.6v-.6c0-.742.602-1.344 1.344-1.344h2.4A1.344 1.344 0 0114.592 8.4v.672a1.356 1.356 0 01-.912 1.284l-1.14.372a2.256 2.256 0 00-1.548 2.136v.936a.6.6 0 00.6.6h.912a.6.6 0 00.6-.6v-.936c0-.063.038-.12.096-.144l1.056-.372z",
    clipRule: "evenodd"
  });
};

exports.QuestionMarkFill = QuestionMarkFill;